
export {} from '@clayui/tabs';
import __x__ from '@clayui/tabs';export default __x__;